export default function PHP_getmxrr() {
  return (
    <div>
      <h1>PHP_getmxrr</h1>
    </div>
  );
}
